import { Component } from '@angular/core';
import { PolicyDetailsComponent } from '../policy-details/policy-details.component';
import { CoverpathUtils } from '../../../../js/static/CoverpathUtils';

@Component({
  moduleId: module.id,
  selector: 'policy-details-cir',
  templateUrl: './policy-details-cir.component.html',
})
export class PolicyDetailsCirComponent extends PolicyDetailsComponent {
  cirFilingNumber: string = CoverpathUtils.getCirFilingNumber();
}
